import { render } from "./add-language.vue?vue&type=template&id=513ed3f6"
import script from "./add-language.vue?vue&type=script&lang=js"
export * from "./add-language.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__